var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "fit-content" } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _vm._l(_vm.upElementBlocks, function(item, index) {
            return [
              _c(
                "div",
                {
                  key: index,
                  staticClass: "section form-column",
                  style: { width: item.width + "px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "135px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._l(item.elementNames, function(elementName) {
                        return [
                          _vm._t(elementName),
                          elementName === "jobNo"
                            ? [
                                _vm._t("saleProductCode"),
                                _vm._t("fullOrInside")
                              ]
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          })
        ],
        2
      ),
      _vm._t("ticketsInfo")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }